import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toIds } from './values';

export function resorts(query: QueryObject): Pick<SearchCriteriaParams, 'resorts'> | null {
  const ids = toIds(query.toCity);

  return ids.length ? { resorts: ids } : null;
}
